import { faker } from '@faker-js/faker';
import { sample } from 'lodash';

// ----------------------------------------------------------------------

const PRODUCT_NAME = [
  'Eco-friendly reusable water bottle brand',
  'Online marketplace for second-hand designer clothing',
  'Customized phone case company',
  'Plant-based meal delivery service',
  'Virtual personal shopping and styling service',
  'Organic skincare line',
  'Smart home automation installation and consulting',
  'Luxury pet grooming and daycare services',
  'Subscription box service for artisanal snacks and treats',
  'Fitness equipment rental company',
  'Online language learning platform',
  'Sustainable home cleaning and organization service',
  'Virtual event planning and coordination',
  'Social media management and consulting agency',
  'Customized meal prep service for busy professionals',
  'Innovative sustainable fashion brand',
];
const PRODUCT_COLOR = ['#00AB55', '#000000', '#FFFFFF', '#FFC0CB', '#FF4842', '#1890FF', '#94D82D', '#FFC107'];

// ----------------------------------------------------------------------

const products = [...Array(24)].map((_, index) => {
  const setIndex = index + 1;

  return {
    id: faker.datatype.uuid(),
    cover: `/assets/images/products/products_${setIndex}.jpg`,
    name: PRODUCT_NAME[index],
    price: faker.datatype.number({ min: 4, max: 99, precision: 0.01 }),
    priceSale: setIndex % 3 ? null : faker.datatype.number({ min: 19, max: 29, precision: 0.01 }),
    colors:
      (setIndex === 1 && PRODUCT_COLOR.slice(0, 2)) ||
      (setIndex === 2 && PRODUCT_COLOR.slice(1, 3)) ||
      (setIndex === 3 && PRODUCT_COLOR.slice(2, 4)) ||
      (setIndex === 4 && PRODUCT_COLOR.slice(3, 6)) ||
      (setIndex === 23 && PRODUCT_COLOR.slice(4, 6)) ||
      (setIndex === 24 && PRODUCT_COLOR.slice(5, 6)) ||
      PRODUCT_COLOR,
    status: sample(['hot', 'new', '', '']),
  };
});

export default products;
